import React, { useEffect, useState } from "react";
import { Select } from "antd";
import { useSelector } from "react-redux";

let timeout;
let currentValue;

const url = process.env.REACT_APP_API_BASE_RECRUITMENT;

const fetchFunc = (value, callback, token) => {
  if (timeout) {
    clearTimeout(timeout);
    timeout = null;
  }
  currentValue = value;

  const fetchData = () => {
    fetch(`${url}/emp/fetchPanelMembers.action?pmeName=${value}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `${token}`,
      },
    })
      .then((res) => res.json())
      .then((d) => {
        if (currentValue === value) {
          const data = d?.data?.result?.map((item) => ({
            value: item?.pmeName,
            label: item?.pmeName,
            email: item?.pmeEmail,
            phone: item?.pmePhone,
            role: item?.pmeRole,
          }));
          callback(data);
        }
      });
  };

  if (value) {
    timeout = setTimeout(fetchData, 300);
  }
};

const SearchInput = ({ form, placeholder }) => {
  const [data, setData] = useState([]);
  const [value, setValue] = useState("");
  const { token } = useSelector((state) => state.auth);

  const handleSearch = (newValue) => {
    fetchFunc(newValue, (result) => {
      setData(result);
    }, token);
  };

  const handleChange = (newValue) => {
    const selected = data.find((item) => item.value === newValue);
    setValue(newValue);

    if (selected) { 
      form.setFieldsValue({
        pmeName: selected.value,
        pmeEmail: selected.email,
        pmeRole: selected.role,
        ppTelephone: selected.phone?.replace("+", ""),  
      });
    }
  };

  return (
    <Select
      showSearch
      value={value}
      placeholder={placeholder}
      style={{ width: "100%", height: "44px", borderRadius: "8px" }}
      defaultActiveFirstOption={false}
      suffixIcon={null}
      filterOption={false}
      onSearch={handleSearch}
      onChange={handleChange}
      notFoundContent={null}
      options={data}
    />
  );
};

const SearchField = ({ form }) => {
  return <SearchInput form={form} placeholder="Search member" />;
};

export default SearchField;
